import { render, staticRenderFns } from "./OrderPopUp.vue?vue&type=template&id=33d34633&scoped=true&"
import script from "./OrderPopUp.vue?vue&type=script&lang=js&"
export * from "./OrderPopUp.vue?vue&type=script&lang=js&"
import style0 from "./OrderPopUp.vue?vue&type=style&index=0&id=33d34633&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d34633",
  null
  
)

export default component.exports